function checkElementExists(query: string) {
    return document.querySelector(query) !== null;
}

window.addEventListener('load', () => {
    if (checkElementExists('.cases_slider_container')) {
        import(/* webpackChunkName: "case-slider" */ './case-slider').then((module) => {
            module.default();
        });
    }
});
